module.exports = __webpack_public_path__ + "static/media/e.cosentino.e00bb2e7.svg";